import { IBuilderCard } from '../../types/builder';

export const BUILDER_CARD_DEFAULT: IBuilderCard = {
  address: '',
  availableProjectsCount: 0,
  constructTotalCount: 0,
  constructionZone: '',
  description: '',
  foundationYear: 0,
  fullName: '',
  id: 0,
  inn: '',
  isIndividualCalculation: false,
  lastYearConstructCount: 0,
  legalAddress: '',
  logo: '',
  materials: [],
  name: '',
  ogrn: '',
  phone: '',
  projectEndPrice: 0,
  projectStartPrice: 0,
  projects: [],
  projectsType: [],
  regions: [],
  status: '',
  url: '',
  promotions: [],
};
